'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What exactly is a multi-vendor marketplace website?",
    answer: "A multi-vendor marketplace allows multiple sellers to list and sell their products through a single platform, similar to Amazon or Flipkart. Each vendor manages their own listings, while the admin oversees the entire site."
  },
  {
    question: "Does Eratec build custom marketplace platforms like Amazon or Meesho?",
    answer: "Yes, we design and develop fully functional multi-vendor marketplaces tailored to your business goals. From seller dashboards to commission systems, we include everything you need to launch and scale a marketplace platform."
  },
  {
    question: "How do you handle vendor onboarding and management features?",
    answer: "We build seller registration modules, individual vendor dashboards, approval systems, and tools for order and inventory management. This helps streamline onboarding and gives vendors control over their storefronts."
  },
  {
    question: "Can buyers and sellers use the platform on mobile devices?",
    answer: "Absolutely. All our marketplace websites are mobile-responsive and optimized for both Android and iOS devices. We can also develop dedicated mobile apps for a smoother, app-like experience."
  },
  {
    question: "What support will I get after the marketplace goes live?",
    answer: "Eratec offers ongoing technical support, feature updates, performance monitoring, and security maintenance. We ensure your platform runs smoothly, scales effectively, and adapts as your vendor base grows."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center pb-20 ' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                      <span
                        className={`transition-colors duration-200 cursor-pointer 
                          hover:text-purple-600 
                          ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                      >

                      {item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
